// extracted by mini-css-extract-plugin
export default {"hasExpensesPagePillButtons":"HasExpenses_hasExpensesPagePillButtons__s6QKa"};